<template>
    <div class="popup down" :class="classObj">
        <van-popup :value="show" @click-overlay="close">
            <div class="icon-close" @click="close">
                <i class="iconfont icon-s-cuowu-guanbi"></i>
            </div>
            <div class="content">
                <div class="info">
                    <img class="logo" :src="logoUrl" @click.stop="refresh" />
                    <div class="title">{{ $t("downApp.ClickButtonToDownload2") }}</div>
                </div>
                <div class="btns">
                    <div class="item" @click="$refs.SaveVersionPopup.open()">
                        <img class="item__img" src="@/assets/downApp/icon-down1.png" />
                        <div class="txt">{{ $t('downApp.QuickVersion') }}</div>
                        <div class="size">(3.8M)</div>
                    </div>
                    <div class="item" @click="onDownApp(systemConfig.apkUrl)">
                        <img class="item__img" src="@/assets/downApp/icon-down2.png" />
                        <div class="txt">{{ $t('downApp.NormalVersion') }}</div>
                        <div class="size">(28.8M)</div>
                    </div>
                </div>
            </div>
        </van-popup>
        <SaveVersionPopup ref="SaveVersionPopup" :isToHome="false"></SaveVersionPopup>
    </div>
</template>

<script>
import SaveVersionPopup from '@/views/downAppPWA/modules/SaveVersionPopup'
import { getApkUrl } from '@/api/pwa'
import { mapState } from 'vuex'
export default {
    components: {
        SaveVersionPopup
    },
    data() {
        return {
            systemConfig: {}
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        logoUrl() {
            return this.$store.getters.sysConfig?.homeLogoUrl
        },
        show: {
            get() {
                return this.$store.getters.isShowDownAppPopup
            },
            set(val) {
                return val
            }
        }
    },
    created() {
        getApkUrl().then((res) => {
            if (res.code) return
            const D = res.result
            this.systemConfig = D
            this.$store.dispatch('system/setApkUrl', D.apkUrl)
        })
    },
    methods: {
        close() {
            this.$store.dispatch('user/setIsShowDownAppPopup', false)
        },
        onDownApp(url) {
            window.open(url)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {
    &.mobile{
        .icon-close {
            top: auto;
            bottom: -.88rem;
            right: calc(50% - .34rem);
        }
    }

    &.down{
        .van-popup {
            background: transparent;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            overflow: visible !important;
        }
    }
    .icon-close {
        position: absolute;
        top: 0;
        right: -.88rem;
        width: .68rem;
        height: .68rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .06rem;
        cursor: pointer;
        background: var(--theme-popup-close-bg);
        border: .01rem solid var(--theme-popup-close-border);

        i {
            font-size: .28rem;
             color: var(--theme-bright-text);font-weight: bold;
        }
    }

    .content {
        width: 94vw;
        max-width: 360px;
        border-radius: .32rem;
        box-sizing: border-box;
        border: .01rem solid transparent;
        background-image:
            linear-gradient(to right, var(--theme-popup-box-bg), var(--theme-popup-box-bg)),
            linear-gradient(90deg, var(--theme-popup-box-border), var(--theme-popup-box-border));
        background-origin: border-box;
        background-clip: content-box, border-box;
        box-shadow: var(--theme-popup-box-shadow);
        box-sizing: border-box;
        position: relative;
        overflow: auto;

        .info {
            padding: .38rem;
            margin-bottom: .98rem;

            .logo {
                width: auto;
                height: .98rem;
                margin: 0 auto;
                display: block;
                margin-bottom: .18rem;
            }

            .title {
                width: 100%;
                color: $font-component-cool-color;
                line-height: .38rem;
                text-align: center;
                font-size: .36rem;
                margin-top: .08rem;
            }
        }

        .btns {
            height: 1rem;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: .2rem;
            margin-bottom: .8rem;

            &>div.item {
                width: calc(50% - .35rem);
                display: flex;
                align-items: center;
                flex-direction: column;
                padding: 0;
                border-radius: .18rem;
                cursor: pointer;
                box-sizing: border-box;
                border: .01rem solid transparent;
                background-image:
                    linear-gradient(to right, var(--theme-popup-panel-fill), var(--theme-popup-panel-fill)),
                    var(--theme-popup-panel-border);
                background-origin: border-box;
                background-clip: content-box, border-box;
                box-shadow: var(--theme-popup-box-shadow);
                position: relative;

                .item__img {
                    width: 1.5rem;
                    height: 1.28rem;
                    flex-shrink: 0;
                    vertical-align: middle;
                    margin-top: -.48rem;
                }

                .txt {
                    font-style: normal;
                    font-size: .32rem;
                     color: var(--theme-bright-text);line-height: 1.2;
                    margin-bottom: .04rem;
                    margin-top: .1rem;
                }

                .size {
                    color: var(--theme-list-row-border);
                    font-size: .2rem;
                    margin-bottom: .3rem;
                }

                &.act {
                    background-image:
                        linear-gradient(to right, var(--theme-popup-panel-fill), var(--theme-popup-panel-fill)),
                        var(--theme-popup-panel-border);
                }
            }
        }
    }
}
</style>
